import get from './get';
import create from './create';

export default [create, get];
